<template>
  <div>
    <div v-if="isTransparentBgMode" class="transparent-bg-mode-box"></div>
    <div
      class="box home-content-box"
      :class="{ 'transparent-bg-mode': isTransparentBgMode }"
    >
      <top-header></top-header>
      <switch-version></switch-version>
      <pwa-install @isInstallUpdate="isInstallUpdate"></pwa-install>
      <pwa-goto-award-tips-popup v-if="visibleGotoAwardTipsPopup" @close="closeGotoAwardTipsPopup"></pwa-goto-award-tips-popup>
      <pwa-award :isInstall="isInstall"></pwa-award>
      <div class="content">
        <left-side></left-side>
        <div class="right">
          <top-banner class="banner"></top-banner>
          <login-info class="login-info"></login-info>
          <func-union v-if="isLogin" class="func-union"></func-union>
          <select-product></select-product>
          <select-paytype v-if="showChannel"></select-paytype>
          <safe-footer v-if="!isLandscape"></safe-footer>
          <page-footer :paddingMore="showChannel"></page-footer>
        </div>
      </div>
      <service-icon-btn
        v-show="gameId"
        :serverId="pcServerId"
        :roleId="roleId"
        :roleName="roleName"
        :gameId="gameId"
        :isUidLogin="isUidLogin"
        :uid="uid"
        :loginAccount="loginAccount"
      ></service-icon-btn>
      <transition name="fade" mode="out-in">
        <coupon-vip-popup
          v-if="isShowVipCouponPopup"
          @closeCouponPopup="hideVipCouponPopup"
          :couponList="vipCouponList"
        ></coupon-vip-popup>
      </transition>
      <transition name="fade" mode="out-in">
        <coupon-birth-popup
          v-if="isShowBirthCouponPopup"
          @closeCouponPopup="hideBirthCouponPopup"
          :couponList="birthCouponList"
        ></coupon-birth-popup>
      </transition>
      <transition name="fade" mode="out-in">
        <login-popup v-if="isLoginPopup"></login-popup>
      </transition>
      <transition name="fade" mode="out-in">
        <select-role-popup v-if="isSelectRolePopup"></select-role-popup>
      </transition>
      <transition name="fade" mode="out-in">
        <Loading v-show="loading"></Loading>
      </transition>
      <welcome-popup></welcome-popup>
      <notice-popup></notice-popup>
      <jp-notice-popup v-if="isJpPlatform"></jp-notice-popup>
      <UidTokenLoginPopup
        v-bind:visible.sync="visibleTokenLoginPopup"
      ></UidTokenLoginPopup>
      <PopupWindow
        v-if="visiblePayPalNotice"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="jpPayPalTitle"
        :content="jpPayPalContent"
        :autoHeight="true"
        @onConfirm="closePayPalNotice"
        @onCancel="closePayPalNotice"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleDownJpPayType"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="downJpPayTypeTitle"
        :content="downJpPayTypeContent"
        :autoHeight="true"
        @onConfirm="closeDownJpPayType"
        @onCancel="closeDownJpPayType"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleBankPayDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="bankPayDownTitle"
        :content="bankPayDownContent"
        :autoHeight="true"
        @onConfirm="closeBankPayDown"
        @onCancel="closeBankPayDown"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleJpGamePayDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="jpDownGame.title"
        :content="jpDownGame.content"
        :autoHeight="true"
        @onConfirm="closeJpGamePayDown"
        @onCancel="closeJpGamePayDown"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleJpPayDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="jpPayDownTitle"
        :content="jpPayDownContent"
        :autoHeight="true"
        @onConfirm="closeJpPayDown"
        @onCancel="closeJpPayDown"
      ></PopupWindow>
      <PopupWindow
        v-if="isJpLimitPopup"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="jpLimitPopupTitle"
        :content="jpLimitPopupContent"
        :autoHeight="true"
        :disableClose="true"
        :hideButton="true"
        style="z-index: 1001"
      ></PopupWindow>
    </div>
  </div>
</template>

<script>
import UidTokenLoginPopup from '@components/officialWebStore/login/UidTokenLoginPopup';
import NoticePopup from '@components/officialWebStore/NoticePopup.vue';
import JpNoticePopup from '@components/officialWebStore/JpNoticePopup.vue';
import PwaInstall from '@components/officialWebStore/PwaInstall.vue';
import PwaGotoAwardTipsPopup from '@components/officialWebStore/PwaGotoAwardTipsPopup.vue';
import PwaAward from '@components/officialWebStore/PwaAward.vue';
import TopBanner from '@components/officialWebStore/TopBanner.vue';
import TopHeader from '@components/officialWebStore/TopHeader.vue';
import SelectProduct from '@components/officialWebStore/product/SelectProduct.vue';
import ServiceIconBtn from '@components/officialWebStore/ServiceIcon.vue';
import SelectPaytype from '@components/officialWebStore/paytype/SelectPaytype.vue';
import CouponVipPopup from '@components/officialWebStore/coupon/CouponVipPopup.vue';
import CouponBirthPopup from '@components/officialWebStore/coupon/CouponBirthPopup.vue';
import Loading from '@components/officialWebStore/Loading.vue';
import coupon from '@mixins/officialWebStore/coupon';
import login from '@mixins/officialWebStore/login';
import pwa from '@mixins/officialWebStore/pwa';
import userStatus from '@mixins/officialWebStore/userStatus';
import allStorePopup from '@mixins/allStorePopup';
import LoginPopup from '@components/officialWebStore/login/LoginPopup.vue';
import LoginInfo from '@components/officialWebStore/login/LoginInfo.vue';
import FuncUnion from '@components/officialWebStore/FuncUnion.vue';
import SelectRolePopup from '@components/officialWebStore/login/SelectRolePopup.vue';
import LeftSide from '@components/officialWebStore/LeftSide.vue';
import PageFooter from '@components/officialWebStore/PageFooter.vue';
import WelcomePopup from '@components/officialWebStore/WelcomePopup.vue';
import SafeFooter from '@components/officialWebStore/SafeFooter.vue';
import { UPDATE_VISIBLE_TOKEN_LOGIN_POPUP } from '@store/officialWebStore';
import { UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP } from '@store/officialWebStore/page';
import { mapGetters, mapState } from 'vuex';
import bridge from '@utiles/officialStore/bridge';
import SwitchVersion from '@components/officialWebStore/SwitchVersion.vue';
import transparentBg from '@mixins/officialWebStore/transparentBg';
import jpLimitPopup from '@mixins/jpLimitPopup';
export default {
  name: 'webStorePage',
  mixins: [login, userStatus, coupon, pwa, allStorePopup, transparentBg, jpLimitPopup],
  data() {
    return {
      isLandscape: window.innerWidth > window.innerHeight
    };
  },
  computed: {
    ...mapState({
      loading: state => state.loading,
      showChannel: state => state.showChannel,
      letter: state => state.letter,
      serverList: state => state.serverList,
      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      loginAccount: state => state.login.loginAccount,
      uid: state => state.login.uid,
      isUidLogin: state => state.login.isUidLogin,
      lang: state => state.lang,
      visibleGotoAwardTipsPopup: state => state.page.visibleGotoAwardTipsPopup
    }),
    ...mapGetters(['isJpPlatform']),
    visibleTokenLoginPopup: {
      get() {
        return this.$store.state.visibleTokenLoginPopup;
      },
      set(val) {
        this.$store.commit(UPDATE_VISIBLE_TOKEN_LOGIN_POPUP, val);
      }
    }
    // 2024-04-09 :修复因接口请求顺序错误，导致登录态异常
    // isOpenCoupon() {
    //   if (+this.gameId === 274 && this.lang === 'vi-VN') {
    //     return false;
    //   }
    //   return this.gameInfoConfig?.loginCenter?.isOpenCoupon || false;
    // },
    // isOpenVip() {
    //   if (+this.gameId === 274 && this.lang === 'vi-VN') {
    //     return false;
    //   }
    //   return this.gameInfoConfig?.loginCenter?.isOpenVip || false;
    // },
    // ...mapGetters(['gameInfoConfig'])
  },
  created() {
    // 2025-04-10 修复日本平台游戏内拉起第三方支付时，gmo渠道无法正常储值，改为外跳浏览器
    if (this.isJpPlatform) {
      if (bridge.runInsdk() && window.location.pathname == '/mobile/paytype') {
        bridge.callSdkMethod('openBrowser', {
          url: window.location.href,
          loginDir: 1,
          appendParams: 1
        });
      }
    }
  },
  watch: {
    showChannel(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          document
            .getElementById('j-paytype-title')
            ?.scrollIntoView({ behavior: 'smooth' });
        });
      }
    },
    isLogin: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.selectRole();
        }
      }
    },
    isTransparentBgMode: {
      handler(newVal) {
        if (newVal) {
          document.querySelector('html')?.classList.add('transparent-bg-mode');
          document.querySelector('body')?.classList.add('transparent-bg-mode');
        } else {
          document
            .querySelector('html')
            ?.classList.remove('transparent-bg-mode');
          document
            .querySelector('body')
            ?.classList.remove('transparent-bg-mode');
        }
      },
      immediate: true
    }
    // 2024-04-09 :修复因接口请求顺序错误，导致登录态异常（因为当前页面gameid不会动态变更，直接去掉，移到useStatus的login后执行）
    // gameId: {
    //   immediate: true,
    //   handler(newVal) {
    //     if (!newVal) {
    //       return;
    //     }
    //     this.isOpenCoupon && this.loadGameCouponList();
    //     this.isOpenVip && this.loadVipCouponInfo();
    //   }
    // }
  },
  methods: {
    closeGotoAwardTipsPopup() {
      this.$store.commit(UPDATE_VISIBLE_GOTO_AWARD_TIPS_POPUP, false);
    }
  },
  components: {
    PwaInstall,
    PwaGotoAwardTipsPopup,
    PwaAward,
    TopBanner,
    TopHeader,
    SelectProduct,
    ServiceIconBtn,
    CouponVipPopup,
    CouponBirthPopup,
    SelectPaytype,
    Loading,
    LoginPopup,
    LoginInfo,
    SelectRolePopup,
    LeftSide,
    PageFooter,
    FuncUnion,
    WelcomePopup,
    NoticePopup,
    JpNoticePopup,
    UidTokenLoginPopup,
    SafeFooter,
    SwitchVersion
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.box {
  position: relative;
  background-color: $bg;
  width: 100%;
  height: auto;
  min-height: 100%;
}
.content {
  position: relative;
  margin-bottom: 215px;
  .right {
    .banner {
      display: block;
    }
  }
}
.content-box {
  position: relative;
  font-size: 0;
  padding-top: 1px;
}
.step-box {
  position: relative;
  text-align: left;
  transition: all 0.6s;
  box-sizing: border-box;
}

@media screen and (orientation: landscape) {
  .step-box {
    width: 1202px;
    margin: 0 auto;
    padding: 0;
  }
  .content {
    display: flex;
    justify-content: space-between;
    width: 1300px;
    margin: 21px auto;
    .left {
      display: block;
      width: 364px;
      height: 978px;
    }
    .right {
      width: 898px;
      background-color: #ffffff;
      box-shadow: 0px 10px 10px 0px #e7e7e7;
      border-radius: 9px;
      padding: 30px 20px;
      box-sizing: border-box;
      margin-bottom: 20px;
      .banner,
      .login-info,
      .func-union {
        display: none;
      }
      ::v-deep .footer {
        display: none;
      }
    }
  }
}
/* iPad横向方向样式 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .content {
    widows: 1200px;
  }
}
</style>

<style lang="scss">
.home-content-box.transparent-bg-mode {
  overflow-y: scroll;
  height: calc(100vh - 250px);
  .top-header,
  .header-bottom,
  .right .banner,
  .login-center,
  .func-union-wrap,
  .safe-footer-warp,
  .switch-version-btn,
  .product-wrap,
  .select-product-title {
    display: none;
  }
  .has-choose-product {
    margin-top: 30px;
  }
}
.transparent-bg-mode-box {
  height: 250px;
  width: 100%;
  background-color: transparent;
}
html.transparent-bg-mode {
  background-color: transparent;
}
body.transparent-bg-mode {
  background-color: transparent;
  overflow-y: hidden;
}
@media screen and (orientation: landscape) {
  .home-content-box.transparent-bg-mode {
    height: calc(100vh + 250px);
  }
}
</style>
